import { Service, Equipment } from "utils/types";

export function getUniqueCapabilities(
  capabilities: Array<Service | Equipment>
): Array<Service | Equipment> {
  return [...new Set(capabilities)];
}

export default { getUniqueCapabilities };
